import axios from 'axios'
import get from 'lodash/get'
import moment from 'moment'

// Libs
import { parseUrl, Consequence } from '../../libs/utils'

// Endpoints
import {
  INVOICE_SUMARY,
  CUSTOMER_OVERDUE,
  COLLECTION_OVERVIEW,
  SALES_REPORT

} from '../../constants/endpoints';

// Actions
export const NEW_INVOICE_SUMARY      = 'NEW_INVOICE_SUMARY';
export const NEW_CUSTOMER_OVERDUE    = 'NEW_CUSTOMER_OVERDUE';
export const NEW_COLLECTION_OVERVIEW = 'NEW_COLLECTION_OVERVIEW';
export const NEW_SALES_REPORT        = 'NEW_SALES_REPORT';

/* ##################
#### GRAHPS DATA ####
################## */
export function fetchCollectionSumary(params: {}){
  let { startDate, endDate } = params;
  if (!startDate) startDate =  moment().subtract(2, 'months').format('YYYY-MM-DD');
  if (!endDate) endDate =  moment().add(1, 'months').format('YYYY-MM-DD');

  return dispatch => axios.get(parseUrl(INVOICE_SUMARY, { startDate, endDate }))
    .then(res => new Consequence({ dispatch,
      payload: { data: get(res, 'data.data') },
      eventTypes: { success: NEW_INVOICE_SUMARY, error: 'ERROR' }

    }));

} // END fetchCollectionSumary


export function fetchCustomerOverdue(){
  return dispatch => axios.get(CUSTOMER_OVERDUE)
    .then(res => new Consequence({ dispatch,
      payload: { data: get(res, 'data.data') },
      eventTypes: { success: NEW_CUSTOMER_OVERDUE, error: 'ERROR' }

    }));

} // END fetchCustomerOverdue


export function fetchCollectionOverview(){
  return dispatch => axios.get(COLLECTION_OVERVIEW)
    .then(res => new Consequence({ dispatch,
      payload: { data: get(res, 'data.data') },
      eventTypes: { success: NEW_COLLECTION_OVERVIEW, error: 'ERROR' }

    }));

} // END fetchCollectionOverview

export function  fetchSalesReport(){
  const
    year =  moment().year(),
    month =  moment().format('MM');

  return dispatch => axios.get(parseUrl(SALES_REPORT, { year, month }))
    .then(res => new Consequence({ dispatch,
      payload: { data: get(res, 'data.data') },
      eventTypes: { success: NEW_SALES_REPORT, error: 'ERROR' }

    }));
}


// WEBPACK FOOTER //
// ./src/redux/actions/reportsActions.js